import axios from 'axios';
import { Message } from 'element-ui';
import store from '../store';
import { getToken, removeToken } from '@/utils/auth';


// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 50000                  // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['x-access-token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  if ((config.method || 'get').toUpperCase() === 'GET' && config.params && config.formatArray) {
    const params = JSON.parse(JSON.stringify(config.params));

    for (const key in params) {
      if (!params[key]) {
        params[key] = null;
      } else {
        if (params[key] !== null && typeof params[key] === 'object' && params[key] instanceof Array && params[key].length > 0) {
          params[key] = params[key].join(',');
        }
      }
    }

    config.params = params;
  }

  return config;
}, error => {
    // Do something with request error// for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
      const res = response.data || {};

      if (!res.success) {
        Message({
          message: res.errMsg,
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject(res.data);
      } else {
        return response.data;
      }
    },
    error => {
      const response = error.response || {};

      const err = response.data || {};
      if (response.status === 401) { // 添加对 401 状态码的处理
        removeToken(); // 清除 token
        router.push('/login'); // 跳转到登录页
      } else if (!err.success) {
        Message({
          message: err.errMsg || error,
          type: 'error',
          duration: 5 * 1000
        });
      }
      return Promise.reject(error);
    }
)

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js